export const selectConversations = (state) =>
  state.companyChat?.conversations || [];

export const selectConversationsLoading = (state) =>
  state.companyChat?.conversationsLoading || false;

export const selectSelectedUser = (state) =>
  state.companyChat?.selectedUser || null;

export const selectActiveConversation = (state) =>
  state.companyChat?.activeConversation || null;

export const selectMessagesMap = (state) =>
  state.companyChat?.messagesMap || {};

export const selectMessagesLoading = (state) =>
  state.companyChat?.messagesLoading || false;

export const selectSendMessageLoading = (state) =>
  state.companyChat?.sendMessageLoading || false;

export const selectChatError = (state) =>
  state.companyChat?.error || null;
